import { render, staticRenderFns } from "./AdminTerms.vue?vue&type=template&id=f08c6b12&scoped=true"
import script from "./AdminTerms.vue?vue&type=script&lang=js"
export * from "./AdminTerms.vue?vue&type=script&lang=js"
import style0 from "./AdminTerms.vue?vue&type=style&index=0&id=f08c6b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08c6b12",
  null
  
)

export default component.exports